import { useState } from 'react';
import { Link } from 'react-router-dom';

const quickLinks = [
  { label: 'الرئيسية',          to: '/' },
  { label: 'استكشاف الحملات',   to: '/explore' },
  { label: 'ابدأ حملة',         to: '/create' },
  { label: 'من نحن',            to: '/about' },
  { label: 'تواصل معنا',       to: '/contact' },
];

const Footer = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email) return;
    const formData = new URLSearchParams();
    formData.append('email', email);
    try {
      await fetch('https://readdy.ai/api/form/d7dvglc5q56ra7tufs40', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formData.toString(),
      });
      setSubmitted(true);
      setEmail('');
    } catch {
      setSubmitted(true);
    }
  };

  return (
    <footer dir="rtl" className="bg-stone-900 text-white mt-20">
      <div className="max-w-7xl mx-auto px-8 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="md:col-span-1">
            <img
              src="https://static.readdy.ai/image/d635066a0d023485209a64426ae9d593/51fc048e934e5df43d37533356a4b33b.png"
              alt="هِبة"
              className="h-16 md:h-12 w-auto object-contain mb-4 brightness-0 invert"
            />
            <p className="text-stone-400 text-sm leading-relaxed">
              منصة هِبة للتمويل الجماعي والدعم المباشر، نربط المبدعين وأصحاب القضايا بالداعمين في المملكة العربية السعودية.
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a href="https://x.com/d4ymed" target="_blank" rel="noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full bg-stone-800 hover:bg-emerald-600 transition-colors cursor-pointer">
                <i className="ri-twitter-x-line text-sm"></i>
              </a>
              <a href="https://instagram.com/d4ymed" target="_blank" rel="noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full bg-stone-800 hover:bg-emerald-600 transition-colors cursor-pointer">
                <i className="ri-instagram-line text-sm"></i>
              </a>
              <a href="https://snapchat.com/add/d4ymed" target="_blank" rel="noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full bg-stone-800 hover:bg-emerald-600 transition-colors cursor-pointer">
                <i className="ri-snapchat-line text-sm"></i>
              </a>
              <a href="https://youtube.com/@d4ymed" target="_blank" rel="noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full bg-stone-800 hover:bg-emerald-600 transition-colors cursor-pointer">
                <i className="ri-youtube-line text-sm"></i>
              </a>
            </div>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-semibold text-white mb-4 text-sm">روابط سريعة</h4>
            <ul className="space-y-3">
              {quickLinks.map((item) => (
                <li key={item.to}>
                  <Link to={item.to} className="text-stone-400 hover:text-emerald-400 text-sm transition-colors cursor-pointer">{item.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-semibold text-white mb-4 text-sm">قانوني</h4>
            <ul className="space-y-3">
              {['الشروط والأحكام', 'سياسة الخصوصية', 'سياسة الاسترداد', 'الامتثال والترخيص', 'الأسئلة الشائعة'].map((item) => (
                <li key={item}>
                  <a href="#" className="text-stone-400 hover:text-emerald-400 text-sm transition-colors cursor-pointer">{item}</a>
                </li>
              ))}
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h4 className="font-semibold text-white mb-2 text-sm">اشترك في نشرتنا</h4>
            <p className="text-stone-400 text-xs mb-4">احصل على آخر أخبار الحملات والمبدعين</p>
            {submitted ? (
              <div className="bg-emerald-600/20 border border-emerald-600/30 rounded-xl p-3 text-emerald-400 text-sm text-center">
                شكراً! تم اشتراكك بنجاح
              </div>
            ) : (
              <form data-readdy-form onSubmit={handleSubmit} className="flex gap-2">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="بريدك الإلكتروني"
                  className="flex-1 bg-stone-800 border border-stone-700 rounded-xl px-3 py-2 text-sm text-white placeholder-stone-500 focus:outline-none focus:border-emerald-500 text-right"
                  required
                />
                <button
                  type="submit"
                  className="w-10 h-10 flex items-center justify-center bg-emerald-600 hover:bg-emerald-700 rounded-xl transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-send-plane-line text-sm"></i>
                </button>
              </form>
            )}

            {/* Payment Methods */}
            <div className="mt-6">
              <p className="text-stone-500 text-xs mb-3">طرق الدفع المدعومة</p>
              <div className="flex items-center gap-2 flex-wrap">
                {['Apple Pay', 'Mada', 'STC Pay', 'Visa'].map((method) => (
                  <span key={method} className="bg-stone-800 text-stone-300 text-xs px-2 py-1 rounded-md">
                    {method}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-stone-800 mt-12 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-stone-500 text-xs">© 2026 منصة هِبة. جميع الحقوق محفوظة.</p>
          <div className="flex items-center gap-2 text-stone-500 text-xs">
            <i className="ri-shield-check-line text-emerald-500"></i>
            <span>منصة موثوقة ومرخصة في المملكة العربية السعودية</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
